import { Flex, useColorModeValue } from '@chakra-ui/react';
// import { ReactComponent as Logo } from 'assets/img/logo-black.svg';
import img from 'assets/img/Horizon Logo.png';

export function SidebarBrand() {
    return (
        <Flex padding="20px" borderBottom="1px" borderColor="gray.100">
            {/* <Logo /> */}
            <img src={img} alt="" width="147px" height="32px" />
        </Flex>
    );
}

export default SidebarBrand;
